import styled from "styled-components";

interface UnreadProps {
  $unread: boolean;
}

export const Item = styled.div<UnreadProps>`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 14px 18px;
  background: ${(props) => (props.$unread ? "#f7fafd" : "#ffffff")};
  border-bottom: 1px solid #eef1f5;
  cursor: ${(props) => (props.$unread ? "pointer" : "default")};
  transition: background 0.15s;

  &:hover {
    background: ${(props) => (props.$unread ? "#eef4fb" : "#ffffff")};
  }

  &:last-child {
    border-bottom: none;
  }
`;

interface UnreadDotProps {
  $visible: boolean;
}

export const UnreadDot = styled.span<UnreadDotProps>`
  width: 8px;
  height: 8px;
  margin-top: 6px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${(props) => (props.$visible ? props.theme.brand.gold : "transparent")};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-grow: 1;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
`;

export const Title = styled.span<UnreadProps>`
  font-size: 14px;
  font-weight: ${(props) => (props.$unread ? 600 : 500)};
  color: ${(props) => (props.$unread ? props.theme.brand.ink : props.theme.brand.muted)};
  line-height: 1.35;
`;

export const Time = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.brand.soft};
  white-space: nowrap;
`;

export const Message = styled.span<UnreadProps>`
  font-size: 13px;
  color: ${(props) => (props.$unread ? props.theme.brand.muted : props.theme.brand.soft)};
  line-height: 1.5;
`;

export const CtaRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const CtaButton = styled.button`
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: ${(props) => props.theme.colors.primary};
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: ${(props) => props.theme.brand.navyHover};
  }
`;
